import { useDispatch, useSelector } from "react-redux";
import { ACTION_FOR_RESUMING_RANDOM_MODE_TEXTS, ACTION_FOR_STARTING_RANDOM_MODE_TEXTS, ACTIONS_FOR_RESUMING_RANDOM_MODE, ACTIONS_FOR_STARTING_RANDOM_MODE } from "../../utils/constants/userSettingsConstants"
import { getCurrentRandomAlbum } from "../../reducers/randomMode";
import { getCurrentItem } from "../../reducers/playbackState";
import { getActionForResumingRandomMode, getActionForStartingRandomMode } from "../../reducers/userSettings";
import { useEffect, useState } from "react";
import { setClearQueueForResumingRandomMode, setClearQueueForStartingRandomMode } from "../../actions/clearQueueActions";

export const useRandomModeStartingResumingActions = () => {
    const currentRandomAlbum = useSelector(getCurrentRandomAlbum);
    const currentTrack = useSelector(getCurrentItem);
    const selectedStartingAction = useSelector(getActionForStartingRandomMode);
    const selectedResumingValue = useSelector(getActionForResumingRandomMode);

    const [availableActions, setAvailableActions] = useState([]);
    const [mainStartingAction, setMainStartingAction] = useState({});
    const [mainResumingAction, setMainResumingAction] = useState({});

    const dispatch = useDispatch();

    useEffect(() => {
        const startMode = () => {
            dispatch(setClearQueueForStartingRandomMode({ fromCurrentTrack: false }));
        }
        const startModeFromCurrentItem = () => {
            dispatch(setClearQueueForStartingRandomMode({ fromCurrentTrack: true }));
        }
        const resumePausedAlbum = () => {
            dispatch(setClearQueueForResumingRandomMode({ resumePausedAlbum: true }));
        }
        const restartPausedAlbum = () => {
            dispatch(setClearQueueForResumingRandomMode({ resumePausedAlbum: false }));
        }

        const startAction = {
            value: ACTIONS_FOR_STARTING_RANDOM_MODE.start,
            text: ACTION_FOR_STARTING_RANDOM_MODE_TEXTS.start.name,
            onClick: startMode
        };

        const startFromCurrentTrackAction = {
            value: ACTIONS_FOR_STARTING_RANDOM_MODE.startFromCurrentTrack,
            text: ACTION_FOR_STARTING_RANDOM_MODE_TEXTS.startFromCurrentTrack.name,
            onClick: startModeFromCurrentItem
        };

        const resumePausedAlbumAction = {
            value: ACTIONS_FOR_RESUMING_RANDOM_MODE.resumeAlbum,
            text: ACTION_FOR_RESUMING_RANDOM_MODE_TEXTS.resumeAlbum.name,
            onClick: resumePausedAlbum
        };

        const restartPausedAlbumAction = {
            value: ACTIONS_FOR_RESUMING_RANDOM_MODE.restartAlbum,
            text: ACTION_FOR_RESUMING_RANDOM_MODE_TEXTS.restartAlbum.name,
            onClick: restartPausedAlbum
        };

        const resumeFromCurrentTrackAction = {
            value: ACTIONS_FOR_RESUMING_RANDOM_MODE.resumeFromCurrentTrack,
            text: ACTION_FOR_RESUMING_RANDOM_MODE_TEXTS.resumeFromCurrentTrack.name,
            onClick: startModeFromCurrentItem
        };

        const defaultStartingAction = startAction;
        const defaultResumingAction = resumePausedAlbumAction;

        const getAvailableActions = () => {
            let actions = [];

            if(currentRandomAlbum) {
                actions = [...actions,
                    resumePausedAlbumAction,
                    restartPausedAlbumAction
                ];
            } else {
                actions = [...actions,
                    startAction
                ];
            }

            if(currentTrack) {
                actions = [...actions,
                    currentRandomAlbum ?
                    resumeFromCurrentTrackAction :
                    startFromCurrentTrackAction
                ];
            }

            return actions;
        }

        const getMainStartingAction = () => {
            const action = getAvailableActions().find(a => a.value === selectedStartingAction);

            if(!action) {
                return defaultStartingAction;
            }

            return action;
        }

        const getMainResumingAction = () => {
            const action = getAvailableActions().find(a => a.value === selectedResumingValue);

            if(!action) {
                return defaultResumingAction;
            }

            return action;
        }

        setAvailableActions(getAvailableActions());
        setMainStartingAction(getMainStartingAction());
        setMainResumingAction(getMainResumingAction());

    }, [dispatch, currentRandomAlbum, currentTrack, selectedStartingAction, selectedResumingValue]);    

    return {
        availableActions,
        mainStartingAction,
        mainResumingAction
    }
}